const hairDirectory = '../images/gallery/home/';
const Photos = [
  { original: hairDirectory + "1.jpg"},
  { original: hairDirectory + "2.jpg"},
  { original: hairDirectory + "3.jpg"},
  { original: hairDirectory + "4.jpg"},
  { original: hairDirectory + "5.jpg"},
];

export default Photos;